import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getLatestDeployed } from 'Services';
import { getCustomUserName, RQ_DEPLOY_RULES } from 'Utils';

function useLatestDeploy(users?: UsersHashmap, enabled?: boolean) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_DEPLOY_RULES, templateRepositoryId], () => getLatestDeployed(templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0) && enabled !== false,
        select: (data) => {
            return {
                ...data,
                _formatted: {
                    createdBy: getCustomUserName(data.createdBy, users)
                }
            };
        }
    });
}

export default useLatestDeploy;
